import MultiStepForm from './MultiStepForm'
import SimpleForm from './SimpleForm'

const exportObj = {
    MultiStepForm, SimpleForm
}

export default exportObj